export default "__VITE_ASSET__C6V$zG6Y__"